import {newModalFromString} from '../components/modal';
import Customer from './customer';
import FormHelpers from '../util/form';
import Plugins from '../util/plugins';

class RegistrationHelper {
    constructor () {
        this.currentStage = 'email';
    }

    modalRegistrationInit () {
        var _self = this;
        var openingModalCheck = false;
        $('.js-modal-registration').off('click').on('click', function (e) {
            e.preventDefault();
            let socialLogin = $('body').find('.top-section:first').clone();
            _self.closeLoginModal();
            let url = $('#registrationModalURL').data('url');
            if (!url) {
                console.error('Missing URL for AJAX call');
                return;
            }
            if (!openingModalCheck) {
                openingModalCheck = true;
                $.ajax(url).then(data => {
                    var modal = newModalFromString(
                        data, false, ['layer-login-modal', 'cc-registrationModal'], null
                    );
                    modal.open();
                    $('.tingle-modal-box').addClass('rightModalAttribute');
                    $('.registration-modal').addClass('open');
                    $(modal.modalBox)
                        .find('.close-button-info, .js-back-step-arrow')
                        .on('click', function () {
                            modal.close();
                            openingModalCheck = false;
                        });
                    Plugins.init();
                    FormHelpers.init();
                    Customer.accountRegisterForm();
                    _self.buttonSubmissionInit();
                    _self.buttonBackInit();
                    _self.datePickerInit();
                    _self.singleNumberOTPinput();
                    _self.shiftFieldWhileTypingInit();
                    _self.updateButtonStatusInit();
                    _self.passwordMessagesInit();
                    if ($(_self).find('.top-section').length === 0) {
                        $('.js-gigyaLoginWrp').append(socialLogin);
                    }
                    _self.moveToNextStep('email');
                    openingModalCheck = false;
                }).catch(err => {
                    openingModalCheck = false;
                    console.error(err);
                });
            }
        });
    };

    isNewRegistrationActive () {
        return $('#isNewRegistrationActive').val() === 'true';
    }

    isRegistrationModalFlow () {
        return $('.registration-modal').hasClass('open');
    }

    isRegistrationLoyaltyModalFlow () {
        return $('.registration-loyalty-modal').hasClass('open');
    }

    isLoyaltyAvailable () {
        return $('#isLoyaltyAvailable').val() === 'true';
    }

    moveToNextStep (step) {
        $('.registrationModal-box').attr('data-registration-modal-stage', step);
        $('#login-warn-label').addClass('hidden');
        $('#registration-form-phone').attr('placeholder', '');
    }

    handleExistingAccount (data) {
        $('#login-warn-label').text(data.warn);
        $('#login-warn-label').removeClass('hidden');
        $('#registration-form-phone').attr('placeholder', data.hiddenPhonePlaceholder);
    }

    fillEmailText (email) {
        $('span.email-label').text(email);
    }

    fillEmailValue (email) {
        $('#cc-registrationModalEmail').val(email);
    }

    fillPhoneText (phone) {
        $('.phone-label').text(phone);
    }

    fieldsFormPrefill (data) {

        if (data.fieldsForm.loyalty.hide === true) { // At the moment, only registration where a potential customer already has loyalty.
            if (data.fieldsForm.firstName.value) {
                $('#registration-form-fname').val(data.fieldsForm.firstName.value); // First name
                if (data.prefillCustomerData) {
                    $('#registration-form-fname').attr('readonly', 'readonly');
                }
            }

            if (data.fieldsForm.lastName.value) {
                $('#registration-form-lname').val(data.fieldsForm.lastName.value);  // Last name
                if (data.prefillCustomerData) {
                    $('#registration-form-lname').attr('readonly', 'readonly');
                }
            }

            // Gender
            if (data.fieldsForm.gender.value === 'M') {
                $('#gender option[value="1"]').prop('selected', true);  // MALE
                $('#gender').trigger('chosen:updated');
            } else if (data.fieldsForm.gender.value === 'F') {
                $('#gender option[value="2"]').prop('selected', true);  // FEMALE
                $('#gender').trigger('chosen:updated');
            } else if (data.fieldsForm.gender.value === 'X') {
                $('#gender option[value="3"]').prop('selected', true);  // OTHER
                $('#gender').trigger('chosen:updated');
            } else if (data.fieldsForm.gender.value === 'U') {
                $('#gender option[value="4"]').prop('selected', true);  // PREFER NOT TO SAY
                $('#gender').trigger('chosen:updated');
            }

            if (data.fieldsForm.loyalty.hide) {
                $('.cc-registrationModal__loyalty').addClass('hidden'); // Loyalty box
            }

            if (data.prefillPrivacyFlag) {
                $('.prefill-privacy-flag').removeClass('hidden');   // Message about already given privacy consents

                if (data.fieldsForm.directMarketingAgreement.value) {
                    $('#add-to-email-list-yes').prop('checked', true);  // YES - Newsletter

                    $('.js-personalized-news-container').removeClass('transparent');    // Newsletter personalized - box opacity
                    $('#add-to-personalized-news-list-no').removeAttr('disabled');
                    $('#add-to-personalized-news-list-yes').removeAttr('disabled');

                    if (data.fieldsForm.profilingAgreement.value) {
                        $('#add-to-personalized-news-list-yes').prop('checked', true);  // YES - Newsletter personalized
                    } else {
                        $('#add-to-personalized-news-list-no').prop('checked', true);   // NO - Newsletter personalized
                    }

                } else {
                    $('#add-to-email-list-no').prop('checked', true);               // NO - Newsletter
                    $('#add-to-personalized-news-list-no').prop('checked', true);   // NO - Newsletter personalized
                }
            }

            $('.registrationModal-box').attr('data-registration-modal-stage-for-a-loyalty-user', 'true');
        }
    }

    fieldsFormClear () {

        $('#registration-form-fname').val('');  // First name
        $('#registration-form-lname').val('');  // Last name

        $('#gender option[value=""]').prop('selected', true);   // Gender
        $('#gender').trigger('chosen:updated');

        $('.cc-registrationModal__loyalty').removeClass('hidden');  // Loyalty box

        $('.prefill-privacy-flag').addClass('hidden');  // Message about already given privacy consents

        $('#add-to-email-list-yes').prop('checked', false); // YES - Newsletter
        $('#add-to-email-list-no').prop('checked', false);  // NO - Newsletter

        $('.js-personalized-news-container').addClass('transparent');   // Newsletter personalized - box opacity

        $('#add-to-personalized-news-list-yes').prop('checked', false); // YES - Newsletter personalized
        $('#add-to-personalized-news-list-yes').attr('disabled','disabled');
        $('#add-to-personalized-news-list-no').prop('checked', false);   // NO - Newsletter personalized
        $('#add-to-personalized-news-list-no').attr('disabled', 'disabled');

        $('.registrationModal-box').removeAttr('data-registration-modal-stage-for-a-loyalty-user'); // to remove all occurences, if all types of users get their data prefilled
    }

    buttonSubmissionInit () {
        var _self = this;
        $('.js-register-otp').on('click', function (e) {
            e.preventDefault();
            $.spinner().start();
            var $confirmBtn = $(e.currentTarget);
            var $container = $confirmBtn.closest('.js-step-otp, .registration-modal-waiting');
            var email = $('#registration-form-email').val() || $('#unified-email').val();
            var otpCodeInput = '';
            $container.find('.otp-code-input-field').each(function () {
                otpCodeInput += $(this).val();
            });
            let url = $confirmBtn.data('registration-otp-url');
            let formData = {
                email: email,
                otpCodeInput: otpCodeInput
            };
            $.ajax({
                url: url,
                type: 'GET',
                data: formData,
                success: function (data) {
                    if (data.unmatchOtp) {
                        $container.find('.wrong-opt-inserted').removeClass('hidden');
                        $container.find('.expired-opt-inserted').addClass('hidden');
                        $('.opt-in-inputs').addClass('invalid');
                        $('body').trigger('analytics:registerConfirmOptin', { 'error': true });
                        $.spinner().stop();
                        return;
                    } else if (data.expiredOtp) {
                        $container.find('.expired-opt-inserted').removeClass('hidden');
                        $container.find('.wrong-opt-inserted').addClass('hidden');
                        $('.opt-in-inputs').addClass('invalid');
                        $('body').trigger('analytics:registerConfirmOptin', { 'error': true });
                        $.spinner().stop();
                        return;
                    } else if (data.alreadyRegistered) {
                        $container.find('.expired-opt-inserted').addClass('hidden');
                        $container.find('.wrong-opt-inserted').addClass('hidden');
                        _self.closeRegistrationOpenLoginRegistered();
                        $.spinner().stop();
                        return;
                    }
                    $container.find('.expired-opt-inserted').addClass('hidden');
                    $container.find('.wrong-opt-inserted').addClass('hidden');
                    $('body').trigger('analytics:registerConfirmOptin', { 'error': false });
                    _self.loginAfterRegistration();
                    if ($('.page').data('action') === 'Cart-Show') {
                        window.location.reload();
                    } else {
                        $.spinner().stop();
                    }
                },
                error: function () {
                    $.spinner().stop();
                    window.location.href = window.location.origin;
                }
            });
        });
    }

    buttonBackInit () {
        var _self = this;
        $('.js-back-step-arrow').on('click', function (e) {
            var $registrationModal = $('.registrationModal-box');
            var currentStep = $registrationModal.attr('data-registration-modal-stage');
            switch (currentStep) {
            case 'email':
                _self.closeRegistrationOpenLogin();
                break;
            case 'phone' :
                $registrationModal.attr('data-registration-modal-stage', 'email');
                break;
            case 'personal-info' :
                $registrationModal.attr('data-registration-modal-stage', 'phone');
                break;
            case 'waiting-room' :
                $registrationModal.attr('data-registration-modal-stage', 'personal-info');
                break;
            case 'registration' :
                $registrationModal.attr('data-registration-modal-stage', 'content');
                break;
            }
        });
    }

    closeRegistrationOpenLoginInit () {
        var _self = this;
        if (_self.isRegistrationModalFlow()) {
            $('.js-close-registration-open-login').on('click', function (e) {
                e.preventDefault();
                _self.closeRegistrationOpenLogin();
            });
            $('.js-close-registration-open-forgot').on('click', function (e) {
                e.preventDefault();
                _self.forgotPassword(e);
            });
        }
    }

    datePickerInit () {
        var _self = this;
        let formatPattern = $('.datepickerTriggerElement').data('date-format-pattern');

        $('.datepickerTriggerElement').fdatepicker({
            format: formatPattern,
            disableDblClickSelection: true,
            leftArrow: '<<',
            rightArrow: '>>',
            closeIcon: 'X',
            closeButton: false
        }).on('changeDate', function (ev) {
            let date = new Date(ev.date.valueOf() + ev.date.getTimezoneOffset() * 60000);
            var datestring = _self.formatDate(date, formatPattern);
            $('#dpReg').val(datestring);
            $('.datepickerTriggerElement').data('date', datestring);
        });
    }

    proceedToRegistrationLoyaltyInit () {
        $('.js-proceed-to-loyalty-modal').on('click', function () {
            $('body').trigger('analytics:prepareLoyaltySubscription');
            var loyaltyModalBox = $('.modal-loyalty-registration-flow-custom .registrationModal-box');
            if (!loyaltyModalBox.length) {
                loyaltyModalBox = $('#registrationModal-box');
            }
            loyaltyModalBox.attr('data-registration-modal-stage', 'registration');
        });
    }

    loginAfterRegistration (e) {
        var url = $('form.login').attr('action');
        var email = $('#registration-form-email').val();
        var password = $('#registration-form-password').val();
        var csrfToken = $('input[name="csrf_token"]').val();
        var rememberMeChecked = $('#rememberMe').prop('checked') ? 'on' : null;
        var formData = {
            loginEmail: email,
            loginPassword: password,
            csrf_token: csrfToken,
            loginRememberMe: rememberMeChecked
        };
        $.spinner().start();

        // $('form.login').trigger('login:submit', e);
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: formData,
            success: function (data) {
                $.spinner().stop();
                if (!data.success) {
                } else {
                    $('form.login').trigger('login:success', data);
                    location.reload();
                }
            },
            error: function (data) {
                if (data.responseJSON.redirectUrl) {
                    window.location.href = data.responseJSON.redirectUrl;
                } else {
                    $('form.login').trigger('login:error', data);
                    $.spinner().stop();
                }
            }
        });
        return false;
    }

    formatDate (date, formatPattern) {
        if (formatPattern === 'dd-mm-yyyy') {
            return ('0' + date.getDate()).slice(-2) + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' +
                date.getFullYear();
        } else if (formatPattern === 'mm-dd-yyyy') {
            return ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) + '-' +
                date.getFullYear();
        } else if (formatPattern === 'yyyy年mm月dd日') {
            var dateParsed = (date.getFullYear() + '年' + ('0' + (date.getMonth() + 1)).slice(-2) + '月' + ('0' + date.getDate()).slice(-2) + '日');
            return dateParsed;
        }
    }

    closeRegistrationOpenLogin () {
        $('.close-button-info').trigger('click');
        $('.js-layer-login').first().trigger('click');
    }

    closeRegistrationOpenLoginRegistered () {
        $('.close-button-info').trigger('click');
        $('.js-layer-login').first().trigger('click');
        $('.gigyaLoginCell, .social-login-account-accept, .or-divider, .js-loginPopupFooter').addClass('hidden');
        $('.button-login-form').css({'marginBottom': '0'});
        $('.js-layerLoginConfirmRegister').removeClass('hidden');
    }

    singleNumberOTPinput () {
        $('.otp-code-input-field').on('input', function () {
            var sanitizedInput = $(this).val().replace(/[^0-9]/g, '');
            sanitizedInput = sanitizedInput.substring(0, 1);
            $(this).val(sanitizedInput);
        });
    }

    shiftFieldWhileTypingInit () {
        $('.otp-code-input-field').on('input', function () {
            var maxLength = parseInt($(this).attr('maxlength'));
            var $container = $(this).closest('.js-step-otp, .registration-modal-waiting');
            var $inputs = $container.find('.otp-code-input-field');
            var currentInputIndex = $inputs.index(this);

            if ($(this).val().length === maxLength) {
                // Move to the next input field if available
                var nextInputIndex = currentInputIndex + 1;
                var nextInput = $inputs.eq(nextInputIndex);

                if (nextInput.length) {
                    nextInput.focus();
                }
            }
        });

        $('.otp-code-input-field').on('keyup', function (e) {
            var $container = $(this).closest('.js-step-otp, .registration-modal-waiting');
            var $inputs = $container.find('.otp-code-input-field');
            var currentInputIndex = $inputs.index(this);

            if (e.keyCode === 8 && $(this).val().length === 0) {
                // Move to the previous input field if available
                var prevInputIndex = currentInputIndex - 1;
                var prevInput = $inputs.eq(prevInputIndex);
                if (prevInput.length) {
                    prevInput.focus();
                }
            }
        });
    }

    updateButtonStatus () {
        var fname = $('#registration-form-fname').val();
        var lname = $('#registration-form-lname').val();
        var password = $('#registration-form-password').val();
        var confirmPassword = $('#registration-form-password-confirm').val();

        var allFieldsFilled = fname !== '' && lname !== '' && password !== '' && confirmPassword !== '';

        var genderSelected = $('#registration-gender-f').prop('checked') || $('#registration-gender-m').prop('checked') || $('#registration-gender-x').prop('checked') || $('#registration-gender-u').prop('checked');

        if (allFieldsFilled && genderSelected) {
            $('.button-register-final').prop('disabled', false);
        } else {
            $('.button-register-final').prop('disabled', true);
        }
    }

    updateButtonStatusInit () {
        var _self = this;
        $('#registration-form-fname, #registration-form-lname, #registration-form-password, #registration-form-password-confirm, #registration-gender-f, #registration-gender-m, #registration-gender-x, #registration-gender-u').on('input change', function () {
            _self.updateButtonStatus();
        });
        $('#registration-form-email').on('input change', function () {
            var isEmailFilled = $('#registration-form-email').val() !== '';
            $('.registration-page-button').prop('disabled', !isEmailFilled);
        });
        $('#registration-form-phone').on('input change', function () {
            var isPhoneFilled = $('#registration-form-phone').val() !== '';
            $('.registerPhoneButton').prop('disabled', !isPhoneFilled);
        });

        $('.otp-code-input-field').on('input change keyup', function () {
            var $container = $(this).closest('.js-step-otp, .registration-modal-waiting');
            var $inputs = $container.find('.otp-code-input-field');
            var isOtpFilled = $inputs.get().every(function (inp) {
                return $(inp).val().trim() !== '';
            });
            $container.find('.js-register-otp').prop('disabled', !isOtpFilled);
        });
    }

    passwordMessagesInit () {
        $('#registration-form-password').on('input', function () {
            var password = $(this).val();
            $('.minimum-length').toggleClass('active', password.length >= 8);
            $('.capital-letter').toggleClass('active', /[A-Z]/.test(password));
            $('.number').toggleClass('active', /\d/.test(password));
            $('.lower-letter').toggleClass('active', /[a-z]/.test(password));
        });
    }

    closeLoginModal () {
        $('.layer-login-modal .close-button').trigger('click');
    }

    isUserLoyaltyForThisBrand (customerFidelitySubscriptions) {
        if (customerFidelitySubscriptions.length === 0) {
            return false;
        }
        var url = window.location.href;
        for (var i = 0; i < customerFidelitySubscriptions.length; i++) {
            var subscriptionNodeBrandCode = (customerFidelitySubscriptions[i].subscriptionNodeBrandCode).toLowerCase();
            var isLoyaltyForThisBrand = url.indexOf(subscriptionNodeBrandCode) > -1;
            if (isLoyaltyForThisBrand) {
                return true;
            }
        }
        return false;
    }

    forgotPassword (e) {
        $('.close-button-info').trigger('click');
        e.preventDefault();
        const htmlContent = $($(e.currentTarget).data('target')).clone().html();
        // create and open confirmation modal
        const modal = newModalFromString(htmlContent, false, ['resetPwdModal', 'layer-password-modal']);
        $(modal.modalBox).addClass('rightModalAttribute');

        Plugins.init();
        modal.open();
        Customer.resetPasswordForm();

        $(modal.modalBox).find('.request-password-title').removeClass('hidden');
        $(modal.modalBox).find('.social-request-password-title').addClass('hidden');
        $(modal.modalBox).find('.request-password-body-description').removeClass('hidden');
        $(modal.modalBox).find('.social-request-password-body-description').addClass('hidden');
        $(modal.modalBox).on('click', '.close, .btn-close', (e) => {
            e.preventDefault();
            modal.close();
            modal.destroy();
        });
        $(modal.modalBox).on('click', '.back-to-login', (e) => {
            e.preventDefault();
            modal.close();
            modal.destroy();
        });
    };
}

const registrationHelper = new RegistrationHelper();
export default registrationHelper;
